import { AuthenticatedPageLayout } from '@/components/layouts/AuthenticatedPageLayout';
import { AutomationsView } from '@/components/views/AutomationsView';
import React from 'react';

export const AutomationsPage = () => {
	return (
		<AuthenticatedPageLayout>
			<AutomationsView />
		</AuthenticatedPageLayout>
	);
};
